"use strict";

import { dataTemplateConstants } from "../_constants";

export const dataTemplateListRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_LIST_REQUEST,
          payload,
     };
};

export const dataTemplateTypeComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_LIST_COMPLETE,
          payload,
     };
};

export const dataTemplateGetRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_REQUEST,
          payload,
     };
};

export const dataTemplateGetComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_COMPLETE,
          payload,
     };
};

export const dataTemplateTypeListRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_TEMPLATE_LIST_REQUEST,
          payload,
     };
};

export const dataTemplateTypeListComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_TEMPLATE_LIST_COMPLETE,
          payload,
     };
};

export const dataTemplateAddRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_ADD_REQUEST,
          payload,
     };
};

export const dataTemplateAddComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_ADD_COMPLETE,
          payload,
     };
};

export const dataTemplateGetAllSchemeAttributeRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_ALL_SCHEME_ATTRIBUTE_REQUEST,
          payload,
     };
};

export const dataTemplateGetAllSchemeAttributeComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_ALL_SCHEME_ATTRIBUTE_COMPLETE,
          payload,
     };
};

export const dataTemplateGetAllTypesRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_ALL_TYPES_REQUEST,
          payload,
     };
};

export const dataTemplateGetAllTypesComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_ALL_TYPES_COMPLETE,
          payload,
     };
};

export const dataTemplateCreateByCsvUploadRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_CREATE_BY_CSV_REQUEST,
          payload,
     };
};

export const dataTemplateCreateByCsvUploadComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_CREATE_BY_CSV_COMPLETE,
          payload,
     };
};

export const dataTemplateAddSchemaValueRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_ADD_SCHEMA_VALUE_REQUEST,
          payload,
     };
};

export const dataTemplateAddSchemaValueComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_ADD_SCHEMA_VALUE_COMPLETE,
          payload,
     };
};

export const dataTemplateSchemaValueGetRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_GET_REQUEST,
          payload,
     };
};

export const dataTemplateSchemaValueGetComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_GET_COMPLETE,
          payload,
     };
};

export const dataTemplateGetSchemaListRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_ALL_SCHEMA_LIST_REQUEST,
          payload,
     };
};

export const dataTemplateGetSchemaListComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_ALL_SCHEMA_LIST_COMPLETE,
          payload,
     };
};

export const dataTemplateValueDeleteRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_DELETE_REQUEST,
          payload,
     };
};

export const dataTemplateValueDeleteComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_DELETE_COMPLETE,
          payload,
     };
};

export const dataTemplateSchemaValueReOrderRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_REORDER_REQUEST,
          payload,
     };
};

export const dataTemplateSchemaValueReOrderComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_SCHEMA_VALUE_REORDER_COMPLETE,
          payload,
     };
};

export const dataTemplateGetJsonSchemaRequest = (payload) => {
     return {
          type: dataTemplateConstants.GET_DATA_TEMPLATE_JSON_SCHEMA_REQUEST,
          payload,
     };
};

export const dataTemplateGetJsonSchemaComplete = (payload) => {
     return {
          type: dataTemplateConstants.GET_DATA_TEMPLATE_JSON_SCHEMA_COMPLETE,
          payload,
     };
};

export const dataTemplateGetValueRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_VALUE_REQUEST,
          payload,
     };
};

export const dataTemplateGetValueComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_VALUE_COMPLETE,
          payload,
     };
};

export const dataTemplateAddTableRecordRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_ADD_SCHEMA_RECORD_REQUEST,
          payload,
     };
};

export const dataTemplateAddTableRecordComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_ADD_SCHEMA_RECORD_COMPLETE,
          payload,
     };
};

export const dataTemplateGetTableRecordRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_SCHEMA_RECORD_REQUEST,
          payload,
     };
};

export const dataTemplateGetTableRecordComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_SCHEMA_RECORD_COMPLETE,
          payload,
     };
};

export const dataTemplateEditTableRecordRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_EDIT_SCHEMA_RECORD_REQUEST,
          payload,
     };
};

export const dataTemplateEditTableRecordComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_EDIT_SCHEMA_RECORD_COMPLETE,
          payload,
     };
};

export const dataTemplateDeleteRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_DELETE_REQUEST,
          payload,
     };
};

export const dataTemplateDeleteComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_DELETE_COMPLETE,
          payload,
     };
};

export const dataTemplateUpdateRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_UPDATE_REQUEST,
          payload,
     };
};

export const dataTemplateUpdateComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_UPDATE_COMPLETE,
          payload,
     };
};

export const getTemplateLabelsRequest = (payload) => {
     return {
          type: dataTemplateConstants.GET_DATA_TEMPLATE_LABELS_REQUEST,
          payload,
     };
};

export const getTemplateLabelsComplete = (payload) => {
     return {
          type: dataTemplateConstants.GET_DATA_TEMPLATE_LABELS_COMPLETE,
          payload,
     };
};

export const getTemplateTypesRequest = (payload) => {
     return {
          type: dataTemplateConstants.GET_DATA_TEMPLATE_TYPES_REQUEST,
          payload,
     };
};

export const getTemplateTypesComplete = (payload) => {
     return {
          type: dataTemplateConstants.GET_DATA_TEMPLATE_TYPES_COMPLETE,
          payload,
     };
};

export const dataTemplateValueUpdateRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_VALUE_UPDATE_REQUEST,
          payload,
     };
};

export const dataTemplateValueUpdateComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_VALUE_UPDATE_COMPLETE,
          payload,
     };
};

export const dataTemplateDeleteJsonSchemaRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_JSON_SCHEMA_DELETE_REQUEST,
          payload,
     };
};

export const dataTemplateDeleteJsonSchemaComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_JSON_SCHEMA_DELETE_COMPLETE,
          payload,
     };
};

export const dataTemplateGetUserAccountListRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_USER_ACCOUNT_REQUEST,
          payload,
     };
};

export const dataTemplateGetUserAccountListComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_GET_USER_ACCOUNT_COMPLETE,
          payload,
     };
};

export const dataTemplateParticipantUserAccountCreateRequest = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_PARTICIPANT_USER_ACCOUNT_CREATE_REQUEST,
          payload,
     };
};

export const dataTemplateParticipantUserAccountCreateComplete = (payload) => {
     return {
          type: dataTemplateConstants.DATA_TEMPLATE_PARTICIPANT_USER_ACCOUNT_CREATE_COMPLETE,
          payload,
     };
};


